import { DndContext } from '@dnd-kit/core';
import { ChildrenDrawerPortals, useDrawerStore } from '@nexelem/drawer';
import { useEffect } from 'react';
import { useDnDConfig, PlanView } from './hooks';
import Kanban from './Kanban';
import Gantt from './Gantt';
import { useCloseSearchOnViewChange } from './searchComponents';

type CommonProductionPlansProps = {
  view: PlanView;
};

export const ProductionPlans = ({ view }: CommonProductionPlansProps) => {
  const isKanban = view === PlanView.KANBAN;
  const isGantt = view === PlanView.GANTT;

  const config = useDnDConfig();

  const onCloseAllDrawerExceptMenu = useDrawerStore((state) => state.onCloseAllDrawerExceptMenu);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onCloseAllDrawerExceptMenu, []);

  useCloseSearchOnViewChange();

  return (
    <>
      <DndContext {...config}>
        {isGantt && <Gantt />}
        <ChildrenDrawerPortals />
      </DndContext>
      {isKanban && <Kanban />}
    </>
  );
};

ProductionPlans.displayName = 'ProductionPlans';
